import React, { useEffect, useState } from "react";
import { Typography, Button } from "@mhome/ui";
import { Lock, LockOpen, LockClock } from "@mui/icons-material";

const Lock1Widget = ({ widget, onValueUpdate }) => {
  const [status, setStatus] = useState(null);
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    if (!widget) return;
    setWidgetData(widget);

    if (widget.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setStatus(
        currentValue === "" || currentValue === null ? "unknown" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!status) return "unknown";
    return status;
  };

  const isUnlocked = () => {
    return status === "unlocked" || status === "not fully locked";
  };

  const getStatusIcon = () => {
    switch (status) {
      case "locked":
        return <Lock style={{ fontSize: "1.2rem" }} />;
      case "unlocked":
        return <LockOpen style={{ fontSize: "1.2rem" }} />;
      case "not fully locked":
        return <LockClock style={{ fontSize: "1.2rem" }} />;
      default:
        return <Lock style={{ fontSize: "1.2rem" }} />;
    }
  };

  const handleCommand = (command) => {
    if (!widgetData) return;

    const updatedWidget = {
      ...widgetData.items.$w2,
      value: command,
    };
    onValueUpdate(updatedWidget);
  };

  const getActionButton = () => {
    // If locked, show unlock button; otherwise show lock button
    const isLocked = status === "locked" || status === "not fully locked";
    const command = isLocked ? "unlock" : "lock";
    const Icon = isLocked ? LockOpen : Lock;

    return (
      <Button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleCommand(command);
        }}
        variant="contained"
        className="aspect-square min-w-0 p-0 flex-shrink-0 rounded-2xl transition-transform duration-200 active:scale-95 shadow-none"
        style={{ height: "100%" }}
      >
        <Icon style={{ fontSize: "1.2rem" }} />
      </Button>
    );
  };

  return (
    <div className="w-full h-full flex items-center relative gap-2">
      <div
        className="flex items-center justify-center bg-transparent border rounded-2xl px-1 h-full flex-1 min-w-0 transition-colors duration-300 gap-2 overflow-hidden"
        style={{
          borderColor: isUnlocked()
            ? "hsl(var(--primary))"
            : "hsl(var(--border))",
        }}
      >
        {getStatusIcon()}
        <Typography className="text-sm font-medium capitalize whitespace-nowrap overflow-hidden text-ellipsis min-w-0">
          {getStatusText()}
        </Typography>
      </div>

      {getActionButton()}
    </div>
  );
};

export default Lock1Widget;
